<template>
  <router-view class="mx-0 px-0" /> 
</template>
<script>
  export default {
    name: 'void',
    created: function () {
      console.log("Componente creado VOID")
    },
  }
</script>
<style scoped>
</style>
